import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import ChatWidget from '../components/common/ChatWidget';

const PartnerPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="py-12 lg:py-16">
        <div className="container mx-auto px-4">
          {/* Page Header */}
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Unsere Partnerbanken & Immobilienpartner
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Wir arbeiten mit über 500 renommierten Finanzinstituten und Immobilienpartnern zusammen, 
              um Ihnen die besten Konditionen und ein umfassendes Angebot zu garantieren.
            </p>
          </div>

          {/* Finanzierungspartner Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-slate-900 mb-8 text-center">
              Finanzierungspartner
            </h2>
            <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
              <div className="flex justify-center items-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_loan-compare-2/artifacts/ciexb30o_image.png" 
                  alt="Unsere Finanzierungspartner: Allianz, PSD Bank, ING, Alte Leipziger, Deutsche Apotheker- und Ärztebank, AXA, Commerzbank, Degussa Bank, Deutsche Bank, ERGO, Hannoversche, Wüstenrot"
                  className="max-w-full h-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </section>

          {/* Immobilienpartner Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-slate-900 mb-8 text-center">
              Immobilienpartner
            </h2>
            <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
              <div className="flex justify-center items-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_loan-compare-2/artifacts/gfov94hx_image.png" 
                  alt="Unsere Immobilienpartner: BONAVA, bpd, Lübke Kelber, Peters & Peters, Bartz Immobilien, Grundwert, Dennert, Deutsche Reihenhaus, BUWOG, Cloudberry, Specht Immobilien, First Citiz"
                  className="max-w-full h-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="text-center bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-8 lg:p-12 text-white">
            <h2 className="text-2xl lg:text-3xl font-bold mb-4">
              Profitieren Sie von unserem Partnernetzwerk
            </h2>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Stellen Sie jetzt Ihre unverbindliche Anfrage und erhalten Sie die besten Angebote 
              aus unserem umfangreichen Partnernetzwerk.
            </p>
            <a 
              href="/anfrage"
              className="inline-flex items-center gap-2 bg-white text-blue-700 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
            >
              Jetzt Anfrage stellen
            </a>
          </section>
        </div>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default PartnerPage;
